<script module>
  import { resolve } from '$app/paths'
  import { helpPath } from '$lib/help/path'

  export const meta = {
    title: 'Outfits & poses',
    teaser:
      'Learn how to personalize your Pausly experience with outfits and poses. Equip\noutfits for your head and body to showcase your style. Earn outfits by\ncompleting sessions or joining sessions on special days. Poses add an extra\nlayer of fun, with different rarities to acquire and display before sessions.',
    sort: 6,
  }
</script>

<p>
  Outfits are a fantastic way to personalize your Pausly experience. Once you
  obtain outfits, you can equip them and showcase your unique style to everyone
  who views your profile.
</p>
<p>
  When you start a session, the outfit you have chosen will be displayed to
  others, allowing you to impress your friends with your fashion sense.
</p>
<p>
  Outfits in Pausly are divided into two categories: head outfits and body
  outfits. Each user can equip one of each type to create a complete look.
</p>
<h2>How to obtain outfits</h2>
<p>There are two ways to obtain outfits:</p>
<ol>
  <li>
    By earning
    <a href={resolve(helpPath('product/point-and-level-system'))}>points</a>
  </li>
  <li>By completing sessions on specific days</li>
</ol>
<h3>1. Obtaining outfits through points</h3>
<p>
  Every time you accumulate a multiple of 2000 points, you can obtain a
  <em>common</em>
  or <em>rare</em> outfit. The chances of obtaining a common outfit are approximately
  twice as high.
</p>
<p>
  Additionally, for every 10,000 points earned, you will receive an <em>epic</em
  > outfit instead.
</p>
<h3>2. Obtaining legendary outfits</h3>
<p>
  Legendary outfits can only be obtained on specific days. Complete a session on
  designated holidays to acquire them.
</p>
<h2>Strike a Pose!</h2>
<p>
  Beyond outfits, poses add another layer of fun and personal expression to your
  Pausly experience. After earning and selecting your favorite pose, it will be
  showcased to all participants right before a session kicks off. Whether you
  prefer a dynamic dance move, an impressive handstand, or a playful gesture,
  there's a pose for every personality.
</p>
<p>
  Just like outfits, poses come in various rarities: common, rare, epic, and
  legendary, each with its own guidelines for acquisition.
</p>
